import { createI18n } from 'vue-i18n'
import en from './locales/en'
import cs from './locales/cs'

export const defaultLocale = 'en'

export const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || defaultLocale,
  fallbackLocale: defaultLocale,
  messages: {
    en,
    cs
  }
})